// extracted by mini-css-extract-plugin
module.exports = {"btn-submit":"formUserProfile_btn-submit__1fV_P","field-group":"formUserProfile_field-group__JTzLE","form":"formUserProfile_form__32u37"};